const ITEMS = [
  "TOTVS PROTHEUS",
  "ORACLE EBS",
  "SAP B1",
  "TOTVS LOGIX",
  "TOTVS RM",
  "DATASUL",
  "UIPATH",
  "POWER APPS",
  "PYTHON",
  "COPILOT",
  "GEMINI",
  "GPT",
];

export default function LogosMarquee() {
  return (
    <section className="relative py-14 border-y border-cyan-400/10 bg-[#050F26]/50" data-testid="logos-marquee">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-6">
        <p className="label-eyebrow text-center">Stack &amp; ERPs em que somos especialistas</p>
      </div>
      <div className="overflow-hidden">
        <div className="flex marquee-track" style={{ width: "200%" }}>
          {[...ITEMS, ...ITEMS].map((it, i) => (
            <div
              key={i}
              className="shrink-0 px-8 md:px-14 flex items-center gap-3"
            >
              <span className="w-2 h-2 rounded-full bg-cyan-400" />
              <span className="font-mono-tech text-sm md:text-base text-[#B8C0D0] tracking-[0.24em]">
                {it}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
